// src/components/public/LandingPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const API_URL = process.env.REACT_APP_API_URL;


// ── Noticias
const NOTICIAS = [
  {
    id: 1, categoria: 'Auditoría', categColor: '#d97706',
    titulo: 'Próxima Auditoría Interna — Primer Trimestre 2026',
    resumen: 'La Contraloría realizará auditoría de gestión administrativa y financiera durante marzo. Todos los departamentos deben mantener su documentación al día y disponible para revisión.',
    fecha: '01 Mar 2026'
  },
  {
    id: 2, categoria: 'Institucional', categColor: '#2563eb',
    titulo: 'Actualización del Reglamento Interno de Recursos Humanos 2026',
    resumen: 'Se han incorporado nuevas disposiciones sobre trabajo remoto, licencias especiales y beneficios institucionales conforme a la Ley 41-08 de Función Pública.',
    fecha: '15 Feb 2026'
  },
  {
    id: 3, categoria: 'Evaluación', categColor: '#7c3aed',
    titulo: 'Proceso de Evaluación del Desempeño — Primer Semestre 2026',
    resumen: 'A partir del 1 de marzo se inicia el proceso de evaluación semestral. Todos los colaboradores deben completar su autoevaluación antes del 15 de marzo.',
    fecha: '01 Mar 2026'
  },
  {
    id: 4, categoria: 'Beneficios', categColor: '#16a34a',
    titulo: 'Nuevo Seguro de Vida Colectivo para Colaboradores',
    resumen: 'ProDominicana amplía el plan de salud incluyendo cobertura de vida colectiva para todos los colaboradores permanentes a partir del mes de marzo.',
    fecha: '05 Feb 2026'
  },
];

// ── Actividades
const ACTIVIDADES = [
  {
    fecha: '17', mes: 'MAR', hora: '10:30 a.m.',
    titulo: 'Firma de Acuerdo ProDominicana – UNAPEC',
    lugar: 'ProDominicana Capacitación 2'
  },
  {
    fecha: '18–20', mes: 'FEB', hora: 'Todo el día',
    titulo: 'Concordia Horizon Summit Dominican Republic 2026',
    lugar: 'Punta Cana, República Dominicana'
  },
];

// ── Descuentos
const DESCUENTOS = [
  {
    id: 1,
    titulo: "McDonald's",
    descripcion:
      "¡10% de descuento al presentar tu carnet de ProDominicana! Descuento general: 10% en todos sus servicios.",
    color: "#2563eb"
  },
  {
    id: 2,
    titulo: "Spazio",
    descripcion:
      "¡10% de descuento al presentar tu carnet de ProDominicana! Servicios incluidos: peluquería (lavado y secado, corte de puntas, retoque de color, color completo, cirugía capilar, keratina y nanoplastia), uñas (manicure, pedicure, esmaltado normal, gel frío y gel caliente), depilación y tintado. Dirección: C/ Francisco Prats Ramírez No. 26, Esq. Nolberto Torres, Santo Domingo. Tel: 809-740-6631.",
    color: "#ec4899"
  },
  {
    id: 3,
    titulo: "AutoCare",
    descripcion:
      "Descuento general del 10% en servicios de detallado de automóviles. Dirección: C/ Ramón Corripio No. 21, Ensanche Naco.",
    color: "#f97316"
  },
  {
    id: 4,
    titulo: "Hylsa",
    descripcion:
      "Descuentos de 37% en neumáticos, 30% en baterías y 30% en lubricantes. Disponible en sucursales de Av. Winston Churchill, Av. Luperón (Santo Domingo) y Santiago.",
    color: "#0f766e"
  },
  {
    id: 5,
    titulo: "Rostro Perfecto",
    descripcion:
      "10% de descuento en servicios de cejas, pestañas, maquillaje, depilación corporal, faciales, uñas y peluquería. Disponible en sucursales del Distrito Nacional, Santo Domingo Este, San Cristóbal, La Romana y Santiago.",
    color: "#7c3aed"
  }
];

// ══════════ ICONOS ══════════
const IcoLogin = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" /><polyline points="10 17 15 12 10 7" /><line x1="15" y1="12" x2="3" y2="12" /></svg>;
const IcoNews = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2" /><path d="M18 14h-8M15 18h-5M10 6h8v4h-8V6z" /></svg>;
const IcoCake = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8" /><path d="M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2 1 2 1" /><path d="M2 21h20M7 8v2M12 8v2M17 8v2M7 4h.01M12 4h.01M17 4h.01" /></svg>;
const IcoStar = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>;
const IcoCalendar = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>;
const IcoPin = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>;
const IcoClock = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>;
const IcoArrow = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>;
const IcoDiscount = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg>;
const IcoChevron = ({ open }) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transition: 'transform 0.25s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink: 0 }}><polyline points="6 9 12 15 18 9" /></svg>;
const IcoBriefcase = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" /></svg>;
const IcoPhone = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.17h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.74a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.92 16.92z" /></svg>;

// ══════════ HELPERS ══════════
const COLORS = ['#2563eb', '#dc143c', '#16a34a', '#7c3aed', '#d97706', '#0891b2', '#db2777'];
const aColor = i => COLORS[i % COLORS.length];
const initials = n => { if (!n) return '?'; const p = n.trim().split(' '); return (p[0]?.[0] || '') + (p[1]?.[0] || ''); };

const medalColor = anos => {
  const n = parseInt(anos);
  if (n >= 15) return { bg: 'rgba(234,179,8,0.15)', border: 'rgba(234,179,8,0.38)', text: '#fbbf24', glow: 'rgba(234,179,8,0.18)' };
  if (n >= 10) return { bg: 'rgba(148,163,184,0.12)', border: 'rgba(148,163,184,0.32)', text: '#cbd5e1', glow: 'rgba(148,163,184,0.1)' };
  if (n >= 5) return { bg: 'rgba(180,110,40,0.15)', border: 'rgba(180,110,40,0.3)', text: '#d97706', glow: 'rgba(180,110,40,0.12)' };
  return { bg: 'rgba(37,99,235,0.12)', border: 'rgba(37,99,235,0.28)', text: '#60a5fa', glow: 'rgba(37,99,235,0.1)' };
};

// ══════════ ANIVERSARIO GRID — FUERA de LandingPage ══════════
// whileInView en el CONTENEDOR con amount:0.05 garantiza que todas
// las tarjetas aparezcan via stagger sin importar cuántas sean.
const cardVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

const AniversarioGrid = ({ lista }) => (
  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.05 }}
    variants={{ visible: { transition: { staggerChildren: 0.07 } } }}
    style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))', gap: '0.875rem' }}>
    {lista.map((a, i) => {
      const m = medalColor(a.anos);
      const n = parseInt(a.anos);
      const color = aColor(i + 2);
      return (
        <motion.div key={i}
          variants={cardVariants}
          style={{ position: 'relative', borderRadius: '14px', border: `1px solid ${m.border}`, background: 'linear-gradient(145deg,rgba(255,255,255,0.04),rgba(255,255,255,0.015))', padding: '1.1rem', boxShadow: `0 4px 18px ${m.glow}` }}>
          {/* barra top */}
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', borderRadius: '14px 14px 0 0', background: `linear-gradient(90deg,${m.text},${m.text}44)` }} />
          {/* Badge años — esquina superior derecha */}
          <div style={{ position: 'absolute', top: '0.85rem', right: '0.85rem', background: m.bg, border: `1px solid ${m.border}`, borderRadius: '8px', padding: '0.18rem 0.52rem', textAlign: 'center', lineHeight: 1.1, zIndex: 1 }}>
            <div style={{ color: m.text, fontSize: '1rem', fontWeight: '800', fontVariantNumeric: 'tabular-nums' }}>{a.anos}</div>
            <div style={{ color: m.text, fontSize: '0.56rem', fontWeight: '700', opacity: 0.8, letterSpacing: '0.04em', textTransform: 'uppercase' }}>{n === 1 ? 'año' : 'años'}</div>
          </div>
          {/* Avatar inline + nombre */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', marginBottom: '0.65rem', paddingRight: '3.5rem' }}>
            <div style={{ width: '42px', height: '42px', borderRadius: '50%', flexShrink: 0, background: `linear-gradient(135deg,${color},${color}99)`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: '700', fontSize: '0.85rem', userSelect: 'none' }}>
              {initials(a.nombre)}
            </div>
            <div style={{ minWidth: 0 }}>
              <p style={{ margin: 0, fontWeight: '700', color: 'white', fontSize: '0.875rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.nombre}</p>
              <p style={{ margin: 0, color: 'rgba(255,255,255,0.4)', fontSize: '0.72rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.puesto}</p>
            </div>
          </div>
          {/* Depto */}
          {a.departamento && (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', background: 'rgba(255,255,255,0.05)', borderRadius: '6px', padding: '0.22rem 0.6rem' }}>
              <IcoBriefcase /><span style={{ color: 'rgba(255,255,255,0.36)', fontSize: '0.7rem' }}>{a.departamento}</span>
            </div>
          )}
        </motion.div>
      );
    })}
  </motion.div>
);

// ══════════ COMPONENTE PRINCIPAL ══════════
export default function LandingPage() {
  const navigate = useNavigate();
  const [noticiaActiva, setNoticiaActiva] = useState(0);
  const [hora, setHora] = useState(new Date());
  const [cumpleanos, setCumpleanos] = useState([]);
  const [aniversarios, setAniversarios] = useState([]);
  const [loadingPersonal, setLoadingPersonal] = useState(false);
  // Cumpleaños y aniversarios solo se ven desde la red de ProDominicana:
  // fuera de ella el backend responde 403 y la sección no se muestra.
  const [redInterna, setRedInterna] = useState(false);
  const [cumpleAbierto, setCumpleAbierto] = useState(null);

  useEffect(() => { const t = setInterval(() => setHora(new Date()), 30000); return () => clearInterval(t); }, []);
  useEffect(() => { const t = setInterval(() => setNoticiaActiva(n => (n + 1) % NOTICIAS.length), 6000); return () => clearInterval(t); }, []);

  useEffect(() => {
    if (!API_URL) return;
    (async () => {
      setLoadingPersonal(true);
      try {
        const [rC, rA] = await Promise.all([
          fetch(`${API_URL}/public/cumpleanos-mes`),
          fetch(`${API_URL}/public/aniversarios-mes`),
        ]);
        if (rC.ok) { setCumpleanos(await rC.json()); setRedInterna(true); }
        if (rA.ok) { setAniversarios(await rA.json()); setRedInterna(true); }
      } catch { /* sin conexión: la sección queda oculta */ }
      setLoadingPersonal(false);
    })();
  }, []);

  const fmtHora = d => { let h = d.getHours(), m = String(d.getMinutes()).padStart(2, '0'); const ap = h >= 12 ? 'p.m.' : 'a.m.'; h = h % 12 || 12; return `${h}:${m} ${ap}`; };
  const fmtFecha = d => { const dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']; const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']; return `${dias[d.getDay()]}, ${d.getDate()} de ${meses[d.getMonth()]} de ${d.getFullYear()}`; };
  const mesActual = () => ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'][new Date().getMonth()];

  const secLabel = color => ({ display: 'flex', alignItems: 'center', gap: '0.4rem', color, fontSize: '0.7rem', fontWeight: '700', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '0.2rem' });
  const secTitle = { margin: 0, fontSize: 'clamp(1.25rem, 4vw, 1.7rem)', fontWeight: '800', color: 'white', letterSpacing: '-0.01em' };
  const barLeft = (c1, c2) => ({ width: '4px', height: '26px', background: `linear-gradient(180deg,${c1},${c2})`, borderRadius: '2px', flexShrink: 0 });
  const card = { background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '12px' };

  // ══ ACORDEÓN CUMPLEAÑOS ══
  const AccordionCumple = ({ lista }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.45rem' }}>
      {lista.map((c, i) => {
        const open = cumpleAbierto === i;
        return (
          <div key={i} style={{ borderRadius: '11px', border: `1px solid ${open ? 'rgba(220,20,60,0.32)' : 'rgba(255,255,255,0.07)'}`, background: open ? 'rgba(220,20,60,0.055)' : 'rgba(255,255,255,0.025)', transition: 'all 0.22s' }}>
            <div onClick={() => setCumpleAbierto(open ? null : i)}
              style={{ padding: '0.75rem 0.9rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <div style={{ width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0, background: `linear-gradient(135deg,${aColor(i)},${aColor(i)}99)`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: '700', fontSize: '0.78rem', userSelect: 'none' }}>
                {initials(c.nombre)}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ margin: 0, fontWeight: '600', color: 'white', fontSize: '0.845rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.nombre}</p>
                <p style={{ margin: 0, color: 'rgba(255,255,255,0.38)', fontSize: '0.72rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.puesto}</p>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
                <span style={{ background: 'rgba(220,20,60,0.15)', border: '1px solid rgba(220,20,60,0.3)', color: '#f87171', borderRadius: '7px', padding: '0.2rem 0.55rem', fontSize: '0.7rem', fontWeight: '700', whiteSpace: 'nowrap' }}>
                  {c.dia} {c.mes_corto || ''}
                </span>
                <IcoChevron open={open} />
              </div>
            </div>
            <AnimatePresence initial={false}>
              {open && (
                <motion.div key="body" initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.22, ease: 'easeInOut' }} style={{ overflow: 'hidden' }}>
                  <div style={{ padding: '0 0.9rem 0.875rem 3.45rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                    {c.departamento && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', background: 'rgba(255,255,255,0.06)', borderRadius: '6px', padding: '0.25rem 0.6rem', color: 'rgba(255,255,255,0.48)', fontSize: '0.72rem' }}>
                        <IcoBriefcase /> {c.departamento}
                      </span>
                    )}
                    {c.telefono && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', background: 'rgba(255,255,255,0.06)', borderRadius: '6px', padding: '0.25rem 0.6rem', color: 'rgba(255,255,255,0.48)', fontSize: '0.72rem' }}>
                        <IcoPhone /> {c.telefono}
                      </span>
                    )}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#0a1628', fontFamily: "'Segoe UI', system-ui, sans-serif", overflowX: 'hidden' }}>

      {/* ══ NAVBAR ══ */}
      <motion.nav initial={{ y: -60, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.5 }}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, background: 'rgba(10,22,40,0.96)', backdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(255,255,255,0.07)', padding: '0 1.25rem', height: '58px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <img src="/ProDominicana Logo FC.png" alt="ProDominicana" style={{ height: '30px', width: 'auto' }} />
          <div style={{ width: '1px', height: '22px', background: 'rgba(255,255,255,0.12)' }} />
          <span className="nav-label" style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.68rem', fontWeight: '600', letterSpacing: '0.08em', textTransform: 'uppercase' }}>ProTalentHub</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.875rem' }}>
          <span className="nav-clock" style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.75rem', fontVariantNumeric: 'tabular-nums' }}>{fmtHora(hora)}</span>
          <button onClick={() => navigate('/login')}
            style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.45rem 1rem', borderRadius: '8px', border: '1.5px solid rgba(255,255,255,0.16)', background: 'rgba(37,99,235,0.22)', color: 'white', fontSize: '0.8rem', fontWeight: '700', cursor: 'pointer', transition: 'all 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(37,99,235,0.55)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(37,99,235,0.22)'}>
            <IcoLogin /> Iniciar sesión
          </button>
        </div>
      </motion.nav>

      {/* ══ HERO ══ */}
      <div style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'url("/images/ProD Back.jpg")', backgroundSize: 'cover', backgroundPosition: 'center' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(10,22,40,0.94) 0%, rgba(10,22,40,0.5) 55%, rgba(10,22,40,0.9) 100%)' }} />
        <div style={{ position: 'relative', zIndex: 2, minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', padding: '80px 5vw 3rem', maxWidth: '1200px', margin: '0 auto', width: '100%', boxSizing: 'border-box' }}>
          <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3, duration: 0.8 }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', background: 'rgba(37,99,235,0.18)', border: '1px solid rgba(37,99,235,0.38)', borderRadius: '999px', padding: '0.3rem 0.9rem', marginBottom: '1.25rem' }}>
              <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#60a5fa', animation: 'pulse 2s infinite' }} />
              <span style={{ color: '#93c5fd', fontSize: '0.7rem', fontWeight: '700', letterSpacing: '0.06em', textTransform: 'uppercase' }}>Sistema ProTalentHub — En línea</span>
            </div>
            <h1 style={{ fontSize: 'clamp(1.85rem, 6vw, 3.5rem)', fontWeight: '800', color: '#fff', margin: '0 0 0.875rem 0', lineHeight: 1.12, letterSpacing: '-0.02em', maxWidth: '640px' }}>
              Portal de Talento<br /><span style={{ color: '#60a5fa' }}>Humano</span> ProDominicana
            </h1>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 'clamp(0.875rem, 2vw, 1.05rem)', maxWidth: '460px', lineHeight: 1.7, margin: '0 0 2rem 0' }}>
              Centro de Exportación e Inversión de la República Dominicana.<br />Habilitadores de Sueños y Oportunidades.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
              <motion.button whileHover={{ scale: 1.03, y: -2 }} whileTap={{ scale: 0.97 }} onClick={() => navigate('/login')}
                style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.8rem 1.75rem', borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg,#1d4ed8,#2563eb)', color: 'white', fontSize: '0.95rem', fontWeight: '700', cursor: 'pointer', boxShadow: '0 8px 24px rgba(37,99,235,0.38)' }}>
                <IcoLogin /> Acceder al Sistema
              </motion.button>
              <button onClick={() => document.getElementById('actividades').scrollIntoView({ behavior: 'smooth' })}
                style={{ padding: '0.8rem 1.5rem', borderRadius: '10px', border: '1.5px solid rgba(255,255,255,0.16)', background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.8)', fontSize: '0.95rem', fontWeight: '600', cursor: 'pointer' }}>
                Ver Actividades
              </button>
            </div>
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.7, duration: 0.7 }}
            className="clock-card"
            style={{ position: 'absolute', right: '5vw', bottom: '10vh', background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '14px', padding: '1.25rem 1.75rem', textAlign: 'right' }}>
            <div style={{ fontSize: '2rem', fontWeight: '700', color: 'white', letterSpacing: '-0.02em', lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>{fmtHora(hora)}</div>
            <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.73rem', marginTop: '0.4rem', textTransform: 'capitalize' }}>{fmtFecha(hora)}</div>
          </motion.div>
        </div>
        <motion.div animate={{ y: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 2 }}
          style={{ position: 'absolute', bottom: '1.5rem', left: '50%', transform: 'translateX(-50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.3rem', color: 'rgba(255,255,255,0.25)', fontSize: '0.62rem', letterSpacing: '0.1em', textTransform: 'uppercase', cursor: 'pointer', zIndex: 2 }}
          onClick={() => document.getElementById('actividades').scrollIntoView({ behavior: 'smooth' })}>
          <span>Scroll</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9" /></svg>
        </motion.div>
      </div>

      {/* ══ AL DÍA CON PRODOMINICANA ══ */}
      <div id="actividades" style={{ background: '#0d1f35', padding: '3.5rem 5vw' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} style={{ marginBottom: '1.75rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <div style={barLeft('#dc143c', '#f87171')} />
              <div>
                <div style={secLabel('#f87171')}><IcoCalendar /> Comunicación Semanal de Actividades</div>
                <h2 style={secTitle}>Al Día con ProDominicana</h2>
              </div>
            </div>
            <p style={{ margin: '0.75rem 0 0 0', color: 'rgba(255,255,255,0.45)', fontSize: '0.85rem', maxWidth: '620px', lineHeight: 1.65 }}>
              Les compartimos las actividades de la institución del mes. <span style={{ color: '#60a5fa' }}>#AlDíaconProDominicana</span>
            </p>
          </motion.div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem' }}>
            {ACTIVIDADES.map((a, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1, duration: 0.5 }}
                style={{ ...card, padding: '1.25rem', display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                <div style={{ flexShrink: 0, background: 'linear-gradient(135deg,#1d4ed8,#2563eb)', borderRadius: '10px', padding: '0.65rem 0.875rem', textAlign: 'center', minWidth: '58px' }}>
                  <div style={{ fontSize: '1.5rem', fontWeight: '800', color: 'white', lineHeight: 1 }}>{a.fecha}</div>
                  <div style={{ fontSize: '0.6rem', fontWeight: '700', color: 'rgba(255,255,255,0.75)', letterSpacing: '0.1em', textTransform: 'uppercase', marginTop: '0.15rem' }}>{a.mes}</div>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', color: 'rgba(255,255,255,0.38)', fontSize: '0.72rem', marginBottom: '0.35rem' }}><IcoClock /> {a.hora}</div>
                  <p style={{ margin: '0 0 0.4rem 0', fontWeight: '700', color: 'white', fontSize: '0.875rem', lineHeight: 1.35 }}>{a.titulo}</p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', color: '#60a5fa', fontSize: '0.75rem' }}><IcoPin /> {a.lugar}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* ══ CUMPLEAÑOS & ANIVERSARIOS — solo red interna ══ */}
      {redInterna && (
        <div style={{ background: '#091526', padding: '3.5rem 5vw' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '3rem' }}>

            {/* ── CUMPLEAÑOS — ACORDEÓN ── */}
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.25rem' }}>
                <div style={barLeft('#dc143c', '#f87171')} />
                <div>
                  <div style={secLabel('#f87171')}><IcoCake /> Celebraciones del Mes</div>
                  <h3 style={{ ...secTitle, fontSize: 'clamp(1.1rem,3vw,1.4rem)' }}>Cumpleaños de {mesActual()}</h3>
                </div>
              </div>
              {loadingPersonal
                ? <p style={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.82rem' }}>Cargando...</p>
                : cumpleanos.length === 0
                  ? <div style={{ ...card, padding: '1.25rem', textAlign: 'center', color: 'rgba(255,255,255,0.28)', fontSize: '0.82rem' }}>Sin cumpleaños este mes</div>
                  : <AccordionCumple lista={cumpleanos} />
              }
            </motion.div>

            {/* ── ANIVERSARIOS — GRID TARJETAS ── */}
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1, duration: 0.6 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem', marginBottom: '1.25rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={barLeft('#d97706', '#fbbf24')} />
                  <div>
                    <div style={secLabel('#fbbf24')}><IcoStar /> Reconocimiento Institucional</div>
                    <h3 style={{ ...secTitle, fontSize: 'clamp(1.1rem,3vw,1.4rem)' }}>Aniversarios de {mesActual()}</h3>
                  </div>
                </div>
                {/* Leyenda */}
                <div style={{ display: 'flex', gap: '0.6rem', flexWrap: 'wrap' }}>
                  {[{ l: '15+ años', c: '#fbbf24' }, { l: '10+ años', c: '#cbd5e1' }, { l: '5+ años', c: '#d97706' }, { l: '< 5 años', c: '#60a5fa' }].map(x => (
                    <span key={x.l} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.28rem', fontSize: '0.65rem', color: 'rgba(255,255,255,0.32)', fontWeight: '600' }}>
                      <span style={{ width: '8px', height: '8px', borderRadius: '2px', background: x.c, display: 'inline-block', opacity: 0.85 }} />{x.l}
                    </span>
                  ))}
                </div>
              </div>
              {loadingPersonal
                ? <p style={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.82rem' }}>Cargando...</p>
                : aniversarios.length === 0
                  ? <div style={{ ...card, padding: '1.25rem', textAlign: 'center', color: 'rgba(255,255,255,0.28)', fontSize: '0.82rem' }}>Sin aniversarios este mes</div>
                  : <AniversarioGrid lista={aniversarios} />
              }
            </motion.div>

          </div>
        </div>
      )}

      {/* ══ NOTICIAS Y AVISOS ══ */}
      <div id="noticias" style={{ background: '#0d1f35', padding: '3.5rem 5vw' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.75rem', flexWrap: 'wrap', gap: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <div style={barLeft('#2563eb', '#60a5fa')} />
              <div>
                <div style={secLabel('#60a5fa')}><IcoNews /> Comunicaciones Internas</div>
                <h2 style={secTitle}>Noticias y Avisos</h2>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '0.4rem' }}>
              {NOTICIAS.map((_, i) => (
                <button key={i} onClick={() => setNoticiaActiva(i)}
                  style={{ width: i === noticiaActiva ? '24px' : '8px', height: '8px', borderRadius: '4px', border: 'none', background: i === noticiaActiva ? '#2563eb' : 'rgba(255,255,255,0.16)', cursor: 'pointer', transition: 'all 0.3s', padding: 0 }} />
              ))}
            </div>
          </motion.div>
          <AnimatePresence mode="wait">
            <motion.div key={noticiaActiva} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }} transition={{ duration: 0.35 }}
              style={{ ...card, overflow: 'hidden', marginBottom: '1rem' }}>
              <div style={{ background: 'linear-gradient(135deg, rgba(37,99,235,0.12), rgba(10,22,40,0.5))', padding: 'clamp(1.5rem, 4vw, 2.25rem)', minHeight: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                <span style={{ display: 'inline-block', background: NOTICIAS[noticiaActiva].categColor, color: 'white', fontSize: '0.65rem', fontWeight: '700', letterSpacing: '0.08em', textTransform: 'uppercase', padding: '0.25rem 0.75rem', borderRadius: '999px', marginBottom: '0.875rem', width: 'fit-content' }}>
                  {NOTICIAS[noticiaActiva].categoria}
                </span>
                <h3 style={{ margin: '0 0 0.65rem 0', fontSize: 'clamp(1rem,3vw,1.3rem)', fontWeight: '700', color: 'white', lineHeight: 1.35 }}>{NOTICIAS[noticiaActiva].titulo}</h3>
                <p style={{ margin: '0 0 1.1rem 0', color: 'rgba(255,255,255,0.56)', lineHeight: 1.65, fontSize: '0.875rem' }}>{NOTICIAS[noticiaActiva].resumen}</p>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', color: 'rgba(255,255,255,0.3)', fontSize: '0.75rem' }}><IcoClock /> {NOTICIAS[noticiaActiva].fecha}</div>
                  <button onClick={() => navigate('/login')} style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', background: 'none', border: 'none', color: '#60a5fa', fontSize: '0.8rem', fontWeight: '700', cursor: 'pointer' }}>Ver más <IcoArrow /></button>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '0.55rem' }}>
            {NOTICIAS.map((n, i) => (
              <div key={n.id} onClick={() => setNoticiaActiva(i)}
                style={{ padding: '0.8rem 1rem', borderRadius: '10px', cursor: 'pointer', transition: 'all 0.2s', border: `1px solid ${i === noticiaActiva ? 'rgba(37,99,235,0.4)' : 'rgba(255,255,255,0.06)'}`, background: i === noticiaActiva ? 'rgba(37,99,235,0.1)' : 'rgba(255,255,255,0.03)', borderLeft: `3px solid ${i === noticiaActiva ? n.categColor : 'transparent'}` }}>
                <span style={{ fontSize: '0.6rem', fontWeight: '700', color: n.categColor, textTransform: 'uppercase', letterSpacing: '0.08em' }}>{n.categoria}</span>
                <p style={{ margin: '0.22rem 0 0.35rem 0', fontSize: '0.8rem', fontWeight: '600', color: i === noticiaActiva ? 'white' : 'rgba(255,255,255,0.58)', lineHeight: 1.35 }}>{n.titulo.length > 60 ? n.titulo.slice(0, 60) + '…' : n.titulo}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', color: 'rgba(255,255,255,0.24)', fontSize: '0.68rem' }}><IcoClock /> {n.fecha}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ══ DESCUENTOS ══ */}
      <div style={{ background: '#091526', padding: '3.5rem 5vw' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} style={{ marginBottom: '1.75rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <div style={barLeft('#16a34a', '#4ade80')} />
              <div>
                <div style={secLabel('#4ade80')}><IcoDiscount /> Beneficios Exclusivos</div>
                <h2 style={secTitle}>Descuentos con tu Carnet Institucional</h2>
              </div>
            </div>
          </motion.div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1rem' }}>
            {DESCUENTOS.map((d, i) => (
              <motion.div key={d.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1, duration: 0.5 }}
                style={{ ...card, padding: '1.5rem', position: 'relative', overflow: 'hidden', transition: 'border-color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.borderColor = `${d.color}40`}
                onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: `linear-gradient(90deg,${d.color},${d.color}66)` }} />
                <h3 style={{ margin: '0 0 0.6rem 0', fontSize: '0.95rem', fontWeight: '700', color: 'white' }}>{d.titulo}</h3>
                <p style={{ margin: '0 0 1.1rem 0', color: 'rgba(255,255,255,0.5)', fontSize: '0.845rem', lineHeight: 1.6 }}>{d.descripcion}</p>
               {/* <button onClick={() => navigate('/login')} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem', padding: '0.42rem 0.95rem', borderRadius: '7px', border: `1.5px solid ${d.color}40`, background: `${d.color}14`, color: d.color, fontSize: '0.76rem', fontWeight: '700', cursor: 'pointer' }}>
                  Ver beneficio <IcoArrow />
                </button>*/} 
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* ══ CTA BANNER ══ */}
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'url("/images/ProD Back.jpg")', backgroundSize: 'cover', backgroundPosition: 'center top' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg,rgba(10,22,40,0.93),rgba(37,99,235,0.52))' }} />
        <div style={{ position: 'relative', zIndex: 2, padding: '3.5rem 5vw', maxWidth: '1200px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1.5rem' }}>
          <div>
            <h2 style={{ margin: '0 0 0.6rem 0', fontSize: 'clamp(1.3rem,4vw,2.1rem)', fontWeight: '800', color: 'white', letterSpacing: '-0.02em' }}>Gestiona tu vida laboral<br />desde un solo lugar</h2>
            <p style={{ margin: 0, color: 'rgba(255,255,255,0.58)', fontSize: '0.9rem', maxWidth: '420px', lineHeight: 1.65 }}>Vacaciones, nómina, capacitaciones, evaluaciones y más — todo en ProTalentHub.</p>
          </div>
          <motion.button whileHover={{ scale: 1.04, y: -2 }} whileTap={{ scale: 0.97 }} onClick={() => navigate('/login')}
            style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', padding: '0.875rem 2rem', borderRadius: '12px', border: 'none', background: 'white', color: '#0d1f35', fontSize: '0.95rem', fontWeight: '800', cursor: 'pointer', boxShadow: '0 12px 32px rgba(0,0,0,0.28)', whiteSpace: 'nowrap' }}>
            <IcoLogin /> Iniciar Sesión Ahora
          </motion.button>
        </div>
      </div>

      {/* ══ FOOTER ══ */}
      <div style={{ background: '#060f1c', padding: '1.5rem 5vw', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
            <img src="/ProDominicana Logo FC.png" alt="ProDominicana" style={{ height: '22px', opacity: 0.55 }} />
            <span style={{ color: 'rgba(255,255,255,0.2)', fontSize: '0.7rem' }}>© {new Date().getFullYear()} ProDominicana — Centro de Exportación e Inversión de la República Dominicana</span>
          </div>
          <span style={{ color: 'rgba(255,255,255,0.16)', fontSize: '0.68rem' }}>ProTalentHub v2.0</span>
        </div>
      </div>

      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.35} }
        .clock-card { display:none !important; }
        .nav-label  { display:none; }
        .nav-clock  { display:none; }
        @media (min-width:640px)  { .nav-clock  { display:inline !important; } }
        @media (min-width:768px)  { .clock-card { display:block !important; } .nav-label { display:inline !important; } }
      `}</style>
    </div>
  );
}